import {SimpleEnvWrapper} from "../jobs/wrapper/SimpleEnvWrapper";
import {SpendConcentration} from "../jobs/koi/spend-concentration/SpendConcentration";
import {KOIPurchasePriceVariance} from "../jobs/koi/purchase-price-variance/KOIPurchasePriceVariance";
import {MainComponent} from "../components/main/MainComponent";
import {KoiKeyDataFacts} from "../jobs/koi/key-data-facts/KoiKeyDataFacts";
import {KoiSupplierHierarchy} from "../jobs/koi/supplier-hierarchy/KoiSupplierHierarchy";
import {ManageDataPage} from "../pages/manage-data/ManageDataPage";
import {KOICashFlowOptimization} from "../jobs/koi/koi-cash-flow-optimization/KOICashFlowOptimization";
import {KOISupplierSegmentation} from "../jobs/koi/koi-supplier-segmentation/KOISupplierSegmentation";
import {routes} from './routes';
import {OpportunitiesTrello} from "../pages/opportunities-trello/OpportunitiesTrello";
import {TaxonomyEditorPage} from "../pages/taxonomy-editor/TaxonomyEditorPage";
import {ApprovalListPage} from "../pages/approval/ApprovalListPage";
import {ApprovalCategorizationPage} from "../pages/approval/categorization/ApprovalCategorizationPage";
import {ApprovalTaxonomyPage} from "../pages/approval/taxonomy/ApprovalTaxonomyPage";
import {TaxonomyMapperPage} from "../pages/taxonomy-mapper/TaxonomyMapperPage";
import {TaxonomyMapperReviewPage} from "../pages/taxonomy-mapper-review/TaxonomyMapperReviewPage";
import {ReportingPage} from "../pages/reporting/ReportingPage";
import {SupplierNormalizationPage} from "../pages/supplier-normalization/SupplierNormalizationPage";
import {DatasetOverviewPage} from '../pages/data-management/DatasetOverviewPage';
import {DataUploadPage} from '../pages/data-management/upload/DataUploadPage';
import {DataIngestionWrapper} from "../jobs/wrapper/DataIngestionWrapper";
import {DataMappingPage} from "../pages/data-management/DataMappingPage";
import {environment} from "../env";
import {TaxonomySuggestorPage} from "../pages/taxonomy-suggestor/TaxonomySuggestorPage";
import {AdvancedDashboard} from "../pages/advanced/AdvancedDashboard";
import {CategorizationPage} from "../pages/categorization/CategorizationPage";
import {TaxonomyHealthCheckPage} from "../pages/taxonomy-health-checker/TaxonomyHealthCheckPage";
import {BusinessCaseGeneratorPage} from "../pages/business-case-generator/BusinessCaseGeneratorPage";
import {BusinessCaseReportPage} from "../pages/business-case-generator/BusinessCaseReportPage";
import {GoldenRecordPage} from "../pages/golden-record/GoldenRecordPage";
import {TaxonomySuggestionDemoPage} from "../pages/taxonomy-suggestion-demo/TaxonomySuggestionDemoPage";
import {TaxonomySuggesterPageV2} from '../pages/taxonomy-suggester-v2/TaxonomySuggesterPageV2';
import {ContractInsightsPage} from "../pages/contract-insights/pages/ContractInsightsPage";
import {ContractAnalyticsPage} from "../pages/contract-insights/pages/ContractAnalyticsPage";
import {ContractOpportunities} from "../pages/contract-insights/pages/ContractOpportunities";
import {TaxonomyUploadPage} from "../pages/taxonomy-ingestion/TaxonomyUploadPage";
import {TaxonomyOverviewPage} from "../pages/taxonomy-ingestion/TaxonomyOverviewPage";
import {TaxonomyMappingPage} from "../pages/taxonomy-ingestion/TaxonomyMappingPage";
import {TaxonomyIngestionWrapper} from "../jobs/wrapper/TaxonomyIngestionWrapper";
import {KOIOpportunity} from "../pages/opportunity/OpportunityPage";
import {
    PpvOpportunityDetailPage
} from "../pages/opportunity/components/ppv-opportunity-detail/PpvOpportunityDetailPage";
import {SmallPpvComponentDemo} from "../test/echart-react-playground/echart-ppv-demo1";
import {EchartReactPlayground} from "../test/echart-react-playground/echart-react-playground";
import type {RouteOptions, RouteSpecification} from "./routeClasses";
import type {RouteWrapperProps} from "../jobs/wrapper/RouteWrapperProps";
import {ChatPage} from "../pages/chat-agent/ChatPage";
import {DownloadRedirect} from "../pages/chat-agent/DownloadRedirect";
import {DashboardV3} from "../components/dashboard/v3/DashboardV3.tsx";
import {AutoSelectWrapper} from "../jobs/wrapper/AutoSelectWrapper.tsx";

const r = routes; // shortcut
type WO = RouteOptions<RouteWrapperProps, never>; //shortcut

/**
 * No data wrapper
 */
const noD: WO = {
    wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, dataType: 'no_data'}}
}
const noDA: WO = {
    wrapper: SimpleEnvWrapper,
    wProps: {state: {fluid: true, dataType: 'no_data', appSection: 'approval'}}
} // No data wrapper

const auto: WO = {wrapper: AutoSelectWrapper, wProps: {state: {}}}
const sim: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true}}}
const sif: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: false}}}

const dwmNoData: WO = {
    wrapper: DataIngestionWrapper,
    wProps: {state: {fluid: true, dataType: 'no_data', appSection: 'ingestion'}}
}
const dwmData: WO = {
    wrapper: DataIngestionWrapper,
    wProps: {state: {fluid: true, appSection: 'ingestion'}}
}
const dwmNoTaxonomy: WO = {
    wrapper: TaxonomyIngestionWrapper,
    wProps: {state: {fluid: true, dataType: 'no_data', appSection: 'ingestion'}}
}
const dwmTaxonomy: WO = {
    wrapper: TaxonomyIngestionWrapper,
    wProps: {state: {fluid: true, appSection: 'ingestion'}}
}

const scl: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'cleanup'}}}
const san: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'analytics'}}}
const ssy: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'synergy'}}}
const sop: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true}}} // opportunities
const sre: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true}}} // reporting
const sse: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'settings'}}}

const noWrapper = {wrapper: MainComponent, wProps: {}} as RouteOptions<unknown, object> as WO;

/**
 * TODO: test the user flow on the CategorizationPage routes.
 *  With CAT-1214 we updated all CategorizationV1Page and AiCategorizationPage to CategorizationPage
 *  We would still need to test moved routes for consistency in the navigation flow
 */

// region wrappedRouting
const wrappedRouting: RouteSpecification<RouteWrapperProps>[] = ([] as RouteSpecification<RouteWrapperProps>[]).concat([
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Test routes
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    [noD, r.test_small_ppv_component, SmallPpvComponentDemo],
    [noD, r.test_react_integration, EchartReactPlayground],

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Mithra v3.0 Dashboard
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Cleanup
    [sim, r.cleanup_taxonomy_builder_id, TaxonomyEditorPage],
    [sim, r.cleanup_taxonomy_builder, TaxonomyEditorPage],
    [sim, r.cleanup_categorization, CategorizationPage],
    [sim, r.cleanup_supplier_normalization, SupplierNormalizationPage],
    [sim, r.cleanup_contract_insights, ContractInsightsPage],
    [sim, r.cleanup_golden_record, GoldenRecordPage],

    // Analytics
    [sif, r.analytics_dashboard, AdvancedDashboard],
    [san, r.analytics_koi_kdf, KoiKeyDataFacts],
    [san, r.analytics_koi_sc, SpendConcentration],
    [sim, r.analytics_koi_ppv_opportunity_detail, PpvOpportunityDetailPage],
    [sim, r.analytics_koi_ppv_opportunities, KOIOpportunity],
    [san, r.analytics_koi_ppv, KOIPurchasePriceVariance],
    [sif, r.analytics_koi_ss, KOISupplierSegmentation],

    // Stand-alone cards (to be placed in correct section later)
    // n/a

    // TODO: validate

    // Approval
    [noDA, r.approval_cat_detail, ApprovalCategorizationPage],
    [noDA, r.approval_tax_detail, ApprovalTaxonomyPage],
    [noDA, r.approval, ApprovalListPage],

    // Data Ingestion
    [dwmNoData, r.data_ingestion, DatasetOverviewPage],
    [dwmData, r.data_upload_mapping, DataMappingPage],
    [dwmNoData, r.data_upload, DataUploadPage],

    // Taxonomy Ingestion
    [dwmNoTaxonomy, r.taxonomy_ingestion, TaxonomyOverviewPage],
    [dwmTaxonomy, r.taxonomy_upload_mapping, TaxonomyMappingPage],
    [dwmNoTaxonomy, r.taxonomy_upload, TaxonomyUploadPage],

    // Chat
    [sim, r.chat_download, DownloadRedirect],
    [sim, r.chat, ChatPage],

    // Bases of the app
    // Note: must be last otherwise it will catch all routes
    [auto, r.home, DashboardV3],
    [sim, r.homepage_dashboard, DashboardV3],
]).concat(environment.package === 'cleanup' ? [
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Cleanup dashboard
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Placeholder for routes that interfere with the demo

] : []).concat(environment.package === 'sales_demo' ? [
    [san, r.demo_koi_cfo, KOICashFlowOptimization],
    [san, r.demo_koi_sh, KoiSupplierHierarchy],
    [sop, r.demo_opportunities, OpportunitiesTrello],
    [sop, r.demo_opportunities_id, OpportunitiesTrello],
    [sim, r.demo_merge_taxonomy_mapper_review, TaxonomyMapperReviewPage],
    [sim, r.demo_merge_taxonomy_mapper, TaxonomyMapperPage],
    [sim, r.demo_merge_taxonomy_suggester, TaxonomySuggestorPage],
    [sim, r.demo_opportunities, OpportunitiesTrello],
    [sim, r.demo_manage, ManageDataPage],
    [sif, r.demo_business_case_report_id, BusinessCaseReportPage],
    [sif, r.demo_business_case_report, BusinessCaseGeneratorPage],
    [scl, r.demo_cleanup_taxonomy_health_check, TaxonomyHealthCheckPage],
    [scl, r.demo_cleanup_taxonomy_suggestion_v1, TaxonomySuggestionDemoPage],
    [scl, r.demo_cleanup_taxonomy_suggestion_v2, TaxonomySuggesterPageV2],
    [san, r.demo_cleanup_analytics_contract_opportunities, ContractOpportunities],
    [san, r.demo_cleanup_analytics_contract_analytics, ContractAnalyticsPage],
    [ssy, r.demo_report, ReportingPage],
] : []);
// endregion

// cast the specific type used in this file to a generic type used by the main router
export const routing: RouteSpecification[] = ([] as RouteSpecification[])
    .concat(wrappedRouting as RouteSpecification[])
// Add more routes like this: .concat([] as RouteSpecification[])
